export default __webpack_public_path__ + "static/media/icon-arrow-left.be36d08e.svg";